import { getDomainUrl } from 'core/utils';

export const customerContactListPath = (trigger?: string) =>
  `/contact/customer/list${trigger ? `?trigger=${trigger}` : ''}`;

export const vendorContactListPath = (trigger?: string) =>
  `/contact/vendor/list${trigger ? `?trigger=${trigger}` : ''}`;

export const oldContactsPath = () => `${getDomainUrl()}/contacts`;
